import { CheckboxFilterTree } from "@jana-technology/platform-ui";

import { LoadingSpinner } from "components/loaders";
import { useGlobalFiltersContext } from "contexts/filters/global-filters";
import { useSystemOverviewFiltersContext } from "contexts/filters/system-overview-filters";
import { HierarchyIdToaster } from "./HierarchyIdToaster";

export const OverviewAssetSelection = () => {
  const {
    setAppliedHierarchyIdCheckboxStatesOverview,
    hierarchyIdCheckboxes,
    assetSelectionQueryResult,
  } = useGlobalFiltersContext();
  const {
    selectedHierarchyIdCheckboxStatesOverview,
    setSelectedHierarchyIdCheckboxStatesOverview,
  } = useSystemOverviewFiltersContext();

  const hierarchyIdsKeys = Object.keys(
    selectedHierarchyIdCheckboxStatesOverview,
  );
  const submitDisabled = hierarchyIdsKeys.every(
    (key) => selectedHierarchyIdCheckboxStatesOverview[key] === false,
  );

  return (
    <HierarchyIdToaster
      selectedHierarchyIdsLength={hierarchyIdsKeys.length}
      submitDisabled={submitDisabled}
    >
      <section>
        <div className="h3 text-sm uppercase text-grey-700">
          Asset Selection
        </div>
        <div className="mt-6">
          <LoadingSpinner
            loading={assetSelectionQueryResult.loading}
            className="h-[79px] w-[280px]"
          >
            {hierarchyIdsKeys.length > 0 && (
              <CheckboxFilterTree
                onCheckedChange={setSelectedHierarchyIdCheckboxStatesOverview}
                checkedState={selectedHierarchyIdCheckboxStatesOverview}
                submitDisabled={submitDisabled}
                submitButtonOnClick={() => {
                  setAppliedHierarchyIdCheckboxStatesOverview(
                    selectedHierarchyIdCheckboxStatesOverview,
                  );
                }}
                buttonText="Apply Asset Selection"
                fullFilterTree={hierarchyIdCheckboxes}
                filters={hierarchyIdCheckboxes}
                defaultExpandedValues={Object.keys(
                  selectedHierarchyIdCheckboxStatesOverview,
                )}
              />
            )}
          </LoadingSpinner>
        </div>
      </section>
    </HierarchyIdToaster>
  );
};

export default OverviewAssetSelection;
